import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puz42 = () => {
    return (
        <div>
            <NavLink to='/category/Puzzels/Puzzel43'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Puzzels/Puzzel41'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'70px'}}>&lt;-   Previous page </Button>
</NavLink>
<article class="container">
    <h1 class="title">Placing the numbers</h1>
    
    <div class="text">
        <div>
            <div>Place the numbers<b> 1, 2, 3, 4, 5, 6, 7, 8</b> into the eight circles in figure given below, in such a
                way that no number is adjacent to a number that is next to it in the sequence.For example&nbsp;<b>1</b>
                should not be adjacent to 2 but can be adjacent to <b>3, 4, 5, 6, 7, 8</b>. Similarly for others.</div>
        </div>
        <div></div>
        <div><img class="wp-image-25650 aligncenter"
                src="https://media.geeksforgeeks.org/wp-content/uploads/graph-6.jpg" alt="Geeks" width="424"
                height="288"/></div>
        <p>&nbsp;</p>
          <p>&nbsp;<br/>&nbsp;</p>
          <div class="containers">
        <div><b>Trivial Solution:</b></div>
        <div></div>
        <div>Trying for <b>8!=40320</b> combination would be tedious task.</div>
        <div><b>&nbsp;</b></div>
        <div><b>Smart Solution:</b></div>
        <div><b>&nbsp;</b></div>
        <div>
            <ul>
                <li>The easiest numbers to place are 1 and 8, because each has only one number to which it cannot be
                    adjacent, namely, 2 and 7, respectively. ​</li>
                <li>The hardest circles to fill are those in the middle, as each is adjacent to six others.</li>
            </ul>
        </div>
        <div>This suggests that we place 1 and 8 in the middle circles. If we place 1 to the left of 8, then the only
            possible positions for 2 and 7 are shown figure below:</div>
        <div></div>
        <div><img class="wp-image-25651 aligncenter" src="https://media.geeksforgeeks.org/wp-content/uploads/graphw.jpg"
                alt="Geeks1" width="477" height="323"/></div>
        <div>
            <div>​</div>
            <div>The number 3 must now be placed on the left-hand side of the diagram, and 6 must be placed on the
                right-hand side.</div>
            <div></div>
            <div>Now it is easy to place all the remaining number as shown in figure below:</div>
        </div>
        <div></div>
    </div>
    </div>
</article>
        </div>
    )
}

export default Puz42
